export default __webpack_public_path__ + "static/media/001-about-noun_fast_359305-1-1.b6baa2c9.webp";